import Layout from "../../assets/Layout";
import UserLayout from "../../assets/UserLayout";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import profilePhoto from "../../images/profilePhoto.png";
import VideocamRoundedIcon from "@mui/icons-material/VideocamRounded";
import Rating from "@mui/material/Rating";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import ReviewCard from "../../assets/cards/ReviewCard";
import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getAvailabilityById, getServiceById } from "../../actions/userAuth";
import { enqueueSnackbar } from "notistack";
import DatePicker from 'react-datepicker';

export default function ServiceDetails2() {
  const [value, onChange] = useState(new Date());
  const [service, setService] = useState("");
  const [currentSession, setCurrentSession] = useState([0]);
  const [availability, setAvailability] = useState([]);
  const [selectedEndTime, setSelectedEndTime] = useState(null);
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getServiceById({ id }, (data) => {
      setService(data.data.data);
      dispatch(getAvailabilityById({ id: data.data.data.coach._id }, (data) => {
        setAvailability(data.data.data[0].availability);
      }))
    }))
  }, [id]);

  const handleTimeEndChange = (time) => {
    setSelectedEndTime(time);
  };

  function isTimeInRange(time, startTime, endTime) {
    var date = new Date();
    var start = new Date();
    var end = new Date();

    // Set the time for the given time
    var [hours, minutes, seconds] = time.split(":");
    date.setHours(hours, minutes, seconds);

    // Set the time for the start time
    var [startHours, startMinutes, startSeconds] = startTime.split(":");
    start.setHours(startHours, startMinutes, startSeconds);

    // Set the time for the end time
    var [endHours, endMinutes, endSeconds] = endTime.split(":");
    end.setHours(endHours, endMinutes, endSeconds);

    // Compare the timestamps
    return date >= start && date <= end;
  }

  function isTimeInRangeWithDuration(time, startTime, endTime) {
    var date = new Date();
    var start = new Date();
    var end = new Date();

    var minutes = service?.totalDuration / service?.numberOfSessions;

    var hours1 = Math.floor(minutes / 60); // Calculate the hours
    var remainingMinutes1 = minutes % 60; // Calculate the remaining minutes

    // Set the time for the given time
    var [hours, minutes, seconds] = time.split(":");
    date.setHours(hours + hours1, minutes + remainingMinutes1, seconds);

    // Set the time for the start time
    var [startHours, startMinutes, startSeconds] = startTime.split(":");
    start.setHours(startHours, startMinutes, startSeconds);

    // Set the time for the end time
    var [endHours, endMinutes, endSeconds] = endTime.split(":");
    end.setHours(endHours, endMinutes, endSeconds);

    // Compare the timestamps
    return date >= start && date <= end;
  }

  const [finalTime, setFinalTime] = useState("");

  function convertTo24HourFormat(time) {
    var date = new Date("2000-01-01 " + time); // Use a common date for formatting

    // Extract the hours and minutes from the formatted time
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();

    // Convert to 24-hour format
    var formattedTime = ("0" + hours).slice(-2) + ":" + ("0" + minutes).slice(-2) + ":" + ("0" + seconds).slice(-2);

    return formattedTime;
  }

  const handleAddTime = () => {
    if (!isTimeInRange(convertTo24HourFormat(selectedEndTime.toLocaleTimeString()), convertTo24HourFormat(availability[0].startTime), convertTo24HourFormat(availability[0].endTime))) {
      enqueueSnackbar("Please select a time between coach availability time", { variant: 'warning' });
    } else if (!isTimeInRangeWithDuration(convertTo24HourFormat(selectedEndTime.toLocaleTimeString()), convertTo24HourFormat(availability[0].startTime), convertTo24HourFormat(availability[0].endTime))) {
      enqueueSnackbar("Please select a time which range lies within", { variant: 'warning' });
    } else {
      setFinalTime(selectedEndTime.toLocaleTimeString());
    }
  }

  return (
    <>
      <Layout>
        <UserLayout userRole={"candidate"}>
          <Box sx={{ display: 'flex', flexDirection: 'row', mt: 8, borderRadius: '10px' }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', width: '100%' }}>Service Details</Typography>
            <Grid item md={4} sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', }}>
              {/* <TextField
                sx={{ marginLeft: '1rem', backgroundColor: '#D9E3F6' }}
                className='profile-skills-box text2Light'
                variant="outlined"
                size="small"
                placeholder="Search"

                InputProps={{
                  endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                }}
              /> */}
            </Grid>
          </Box>

          <Grid container spacing={2}>
            <Grid item md={8.5}>
              <Box p={{ md: 3, xs: 1 }}>
                <Paper
                  sx={{
                    width: "100%",
                    bgcolor: "#F8FAFF",
                    boxShadow:
                      "0px 40.30877685546875px 80.6175537109375px -15.115790367126465px #3665D014",
                    border: "1.72px solid #cedefd",
                  }}
                >
                  <Box sx={{ p: 3, display: "flex", flexDirection: { md: 'row', xs: 'column' }, justifyContent: "center" }}>
                    <Box>
                      <img
                        src={service?.coachId?.avatar}
                        alt="profilePhoto"
                        style={{ height: "200px" }}
                      />
                    </Box>
                    <Box sx={{ fontFamily: "Inter", px: 3 }}>
                      <Typography
                        sx={{
                          lineHeight: "43px",
                          opacity: ".5",
                        }}
                        className="text1Mid"
                      >
                        (0)
                      </Typography>
                      <Typography
                        sx={{
                          lineHeight: "40px",
                          color: "#061C3D",
                        }}
                        className="subHeading2Bold"
                      >
                        {service?.coach?.name}
                      </Typography>
                      <Rating
                        name="half-rating-read"
                        defaultValue={4}
                        precision={0.5}
                        readOnly
                        sx={{ py: 1 }}
                        className="text1Bold"
                      />
                      <Typography
                        sx={{
                          lineHeight: "35px",
                        }}
                        className=""
                      >
                        {service?.coach?.description}
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
                <Grid container spacing={2}>
                  <Grid item md={6}>
                    <Typography
                      sx={{
                        fontfamily: "Inter",
                        fontSize: "25px",
                        fontWeight: 600,
                        lineHeight: "75px",
                      }}
                    >
                      Select Time Slot
                    </Typography>
                    <Box>
                      <Calendar onChange={onChange} value={value} />
                    </Box>
                  </Grid>
                  <Grid item md={6}>
                    <Typography
                      sx={{
                        fontfamily: "Inter",
                        fontSize: "25px",
                        fontWeight: 600,
                        lineHeight: "75px",
                      }}
                    >
                      Pick Up Time in Between
                    </Typography>
                    <Box>
                      <Grid container spacing={2}>
                        {[...Array(service?.numberOfSessions)]?.map((item, index) => (
                          <Grid item md={4}>
                            {" "}
                            <Typography
                              onClick={() => {
                                if (currentSession.includes(index)) {
                                  if (index == 0) {
                                    enqueueSnackbar("first session needs to be selected in order to continue", { variant: 'warning' });
                                  } else {
                                    var arr = currentSession.filter((element) => element !== index)
                                    setCurrentSession(arr);
                                  }
                                } else if (!currentSession.includes(index - 1)) {
                                  enqueueSnackbar("previous session needs to be selected in order to select upcoming session", { variant: 'warning' });
                                } else {
                                  setCurrentSession(oldArr => [...oldArr, index])
                                }
                              }}
                              key={index}
                              sx={currentSession.includes(index)
                                ?
                                {
                                  bgcolor: "#2544EE",
                                  color: "#fff",
                                  textAlign: "center",
                                  py: 2,
                                  px: 3,
                                  borderRadius: "30px",
                                  cursor: 'pointer'
                                }
                                :
                                {
                                  border: '1px solid #2544EE',
                                  bgcolor: "#fff",
                                  color: "#2544EE",
                                  textAlign: "center",
                                  py: 2,
                                  px: 3,
                                  borderRadius: "30px",
                                  cursor: 'pointer'
                                }}
                              className="text2Mid"
                            >
                              Session {index + 1}
                            </Typography>
                          </Grid>
                        ))}
                        <Grid item md={12}>
                          {" "}
                          {availability.length > 0
                            ?
                            <Typography
                              sx={{
                                fontfamily: "Inter",
                                fontSize: "18px",
                                fontWeight: 600,
                                border: "1px solid #2544EE",
                                color: "#000",
                                textAlign: "center",
                                py: 2,
                                px: 3,
                                borderRadius: "30px",
                              }}
                            >
                              {availability[0].startTime} - {availability[0].endTime}
                            </Typography>
                            :
                            ""}
                        </Grid>
                        <Grid item md={12}>
                          <Box
                            sx={{
                              bgcolor: "#F8FAFF",
                              boxShadow:
                                "0px 26.398801803588867px 52.797603607177734px -9.89954948425293px #3665D014",
                              border: "1px solid #cedefd",
                              borderRadius: "20px",
                            }}
                          >
                            <Box p={2}>
                              <Typography
                                sx={{
                                  fontfamily: "Inter",
                                  fontSize: "20px",
                                  fontWeight: 600,
                                  mb: 2,
                                }}
                              >
                                Enter Time
                              </Typography>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <DatePicker
                                  selected={selectedEndTime}
                                  onChange={handleTimeEndChange}
                                  showTimeSelect
                                  showTimeSelectOnly
                                  timeIntervals={15}
                                  dateFormat="h:mm aa"
                                  placeholderText="Enter time"
                                  className="timePicker"
                                />
                                <Button
                                  variant="contained"
                                  sx={{ bgcolor: "#2544EE", px: 3 }}
                                  onClick={handleAddTime}
                                >
                                  Done
                                </Button>
                              </Box>
                            </Box>
                          </Box>
                        </Grid>

                        <Grid item md={12}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: { md: 'row', xs: 'column' },
                              justifyContent: "space-between",
                            }}
                          >
                            <Box>
                              <Typography
                                sx={{
                                  fontfamily: "Inter",
                                  fontSize: "25px",
                                  fontWeight: 600,
                                  lineHeight: "75px",
                                }}
                              >
                                Medium
                              </Typography>
                              <Box
                                sx={{
                                  bgcolor: "#2544EE",
                                  color: "#fff",
                                  px: 4,
                                  py: 1,
                                  maxWidth: '90px',
                                  height: "45px",
                                  borderRadius: "30px",
                                }}
                              >
                                <VideocamRoundedIcon />
                              </Box>
                            </Box>
                            <Box>
                              <Box>
                                <Typography
                                  sx={{
                                    fontfamily: "Inter",
                                    fontSize: "25px",
                                    fontWeight: 600,
                                    lineHeight: "75px",
                                  }}
                                >
                                  Language
                                </Typography>
                                <Box display={"flex"} gap={2}>
                                  <Typography
                                    sx={{
                                      fontfamily: "Inter",
                                      fontSize: "14px",
                                      fontWeight: 600,
                                      bgcolor: "#2544EE",
                                      color: "#fff",
                                      textAlign: "center",
                                      py: 2,
                                      px: 3,
                                      borderRadius: "30px",
                                    }}
                                  >
                                    {service?.language && service?.language?.length > 0 && service?.language[0]}
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                </Grid>
                <Grid item md={12}>
                  <Typography
                    sx={{
                      fontfamily: "Inter",
                      fontSize: "25px",
                      fontWeight: 600,
                      lineHeight: "75px",
                    }}
                  >
                    Pick Up Time in Between
                  </Typography>
                  <Box sx={{
                    display: 'flex', flexDirection: { md: 'row', xs: 'column' }, justifyContent: 'space-between', textAlign: 'center', boxShadow: '0px 23.48060417175293px 46.96120834350586px -8.80522632598877px #3665D014', p: 2, borderRadius: '20px', gap: { md: 0, xs: 2 },
                  }}>
                    <Box><Typography sx={{
                      fontfamily: "Inter",
                      fontSize: "16px",
                      fontWeight: 600,
                    }}>{value.toLocaleDateString("en-US", { day: 'numeric', month: 'long', year: 'numeric' })}  at {finalTime} - 03:00 PM</Typography></Box>

                    <Box display={'flex'} gap={1}>
                      <Typography
                        sx={{
                          fontfamily: "Inter",
                          fontSize: "16px",
                          fontWeight: 600,

                        }}
                      >
                        Medium :
                      </Typography>
                      <Box
                        sx={{
                          bgcolor: "#2544EE",
                          color: "#fff",
                          px: 3,
                          borderRadius: "30px",

                        }}
                      >
                        <VideocamRoundedIcon />
                      </Box>
                    </Box>

                    <Box display={'flex'} gap={1}>
                      <Typography
                        sx={{
                          fontfamily: "Inter",
                          fontSize: "16px",
                          fontWeight: 600,

                        }}
                      >
                        Language :
                      </Typography>
                      <Box>
                        <Typography
                          sx={{
                            fontfamily: "Inter",
                            fontSize: "14px",
                            fontWeight: 600,
                            bgcolor: "#2544EE",
                            color: "#fff",
                            textAlign: "center",
                            px: 4,
                            borderRadius: "30px",
                            py: '5px'

                          }}
                        >
                          {service?.language && service?.language?.length > 0 && service?.language[0]}
                        </Typography>


                      </Box>
                    </Box>
                  </Box>
                </Grid>

              </Box>
              <Box sx={{ textAlign: "center" }}>
                <Button
                  variant="contained"
                  className="text1Mid"
                  sx={{
                    px: 5,
                    py: 2,
                    bgcolor: "#2544EE",
                    borderRadius: "10px",
                    my: 5,
                  }}
                  endIcon={<KeyboardArrowRightIcon />}
                >
                  Payment
                </Button>

              </Box>
            </Grid>
            <Grid item md={3.5}>
              <Box py={5}>
                <Typography
                  sx={{
                    fontfamily: "Inter",
                    fontSize: "25px",
                    fontWeight: 600,
                    lineHeight: "75px",
                  }}
                >
                  Social Media
                </Typography>
                <Stack direction="row" spacing={1}>
                  <IconButton sx={{ bgcolor: "#2544EE", color: "#fff" }}>
                    <FacebookRoundedIcon />
                  </IconButton>
                  <IconButton sx={{ bgcolor: "#2544EE", color: "#fff" }}>
                    <TwitterIcon />
                  </IconButton>
                  <IconButton sx={{ bgcolor: "#2544EE", color: "#fff" }}>
                    <LinkedInIcon />
                  </IconButton>
                  <IconButton sx={{ bgcolor: "#2544EE", color: "#fff" }}>
                    <InstagramIcon />
                  </IconButton>
                </Stack>
                <Box>
                  <Typography
                    sx={{
                      fontfamily: "Inter",
                      fontSize: "25px",
                      fontWeight: 600,
                      lineHeight: "75px",
                    }}
                  >
                    Reviews
                  </Typography>
                  <Grid container spacing={2}>
                    {
                      service?.reviews && service?.reviews.length > 0
                        ?
                        <Grid item md={12}><ReviewCard /></Grid>
                        :
                        <Grid item md={12}>
                          <Typography align="center">No reviews</Typography>
                        </Grid>
                    }
                  </Grid>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </UserLayout>
      </Layout>
    </>
  );
}
